// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"462":"legal","564":"sender","884":"admin"}[chunkId] || chunkId) + "." + {"112":"1b5e6281","182":"461eaada","462":"79dfc49b","484":"14cb0921","551":"c2ddb01f","564":"77d38151","629":"3c99ad5f","828":"6cc522b3","884":"8fb6c874"}[chunkId] + ".chunk.js";
};